import { action } from 'easy-peasy';
import { IActionRemoveCarePlanIcd10Code } from '../types';

const removeCarePlanIcd10Code: IActionRemoveCarePlanIcd10Code = action((state, id) => {
  state.items = state.items.filter(item => item.id !== id);
});

export default removeCarePlanIcd10Code;
